module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/eyecatch-campaign-2-f24c83c1fc4561a84b98dd45dee168d2.svg";